<div class="row justify-content-center mt-3 d-flex flex-lg-row-reverse">
    <div class="col-lg-6 col-12 ">
        <div class="row justify-content-center mt-4">
            <div class="col-8 blue_box p-4 text-center">
                <h3 class="heading">Bank Info</h3>
            </div>
        </div>

        <div class="row justify-content-center mt-4 contact-ref-container">
            <div class="col-11 white_box p-4">
                <form [formGroup]="bankForm" (ngSubmit)="onSubmit()" novalidate>
                    <div class="row justify-content-center">
                        <div class="col-11 white_box p-4">
                            <div class="row justify-content-center">
                                <div class="col-12 col-md-10">
                                    <div class="row justify-content-center">

                                        <!-- Account Number -->
                                        <div class="col-12 col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Account Number<span
                                                        class="text-danger">*</span></label>
                                                <input type="text" formControlName="accountNumber" class="form-control"
                                                    placeholder="Enter Account Number" maxlength="18"
                                                    (keypress)="allowOnlyNumbers($event)" />
                                                <div *ngIf="m.accountNumber.touched && m.accountNumber.invalid"
                                                    class="error">
                                                    <div *ngIf="m.accountNumber.errors?.required">Account number is
                                                        required</div>
                                                    <div *ngIf="m.accountNumber.errors?.pattern">Enter a valid account
                                                        number</div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Account Type -->
                                        <div class="col-12 col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Account Type<span
                                                        class="text-danger">*</span></label>
                                                <select formControlName="accountType" class="form-control">
                                                    <option value="" disabled selected>Select Account Type</option>
                                                    <option value="SAVING">Saving</option>
                                                    <option value="CURRENT">Current</option>
                                                </select>
                                                <div *ngIf="m.accountType.touched && m.accountType.invalid"
                                                    class="error">
                                                    <div *ngIf="m.accountType.errors?.required">Please select account
                                                        type</div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Account Holder Name -->
                                        <div class="col-12 col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Account Holder Name<span
                                                        class="text-danger">*</span></label>
                                                <input type="text" formControlName="accountHolderName"
                                                    class="form-control" placeholder="Enter Account Holder Name" />
                                                <div *ngIf="m.accountHolderName.touched && m.accountHolderName.invalid"
                                                    class="error">
                                                    <div *ngIf="m.accountHolderName.errors?.required">Account holder
                                                        name is required
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- IFSC Code -->
                                        <div class="col-12 col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">IFSC Code<span
                                                        class="text-danger">*</span></label>
                                                <input type="text" formControlName="ifscCode"
                                                    class="form-control text-uppercase" maxlength="11"
                                                    placeholder="Enter IFSC Code (e.g. HDFC0001234)" />
                                                <div *ngIf="m.ifscCode.touched && m.ifscCode.invalid" class="error">
                                                    <div *ngIf="m.ifscCode.errors?.required">IFSC code is required</div>
                                                    <div *ngIf="m.ifscCode.errors?.pattern">Enter a valid IFSC code
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <!-- Submit Button -->
                                    <div class="row justify-content-center text-center buttonDiv mt-4">
                                        <div class="col-12">
                                            <button class="btn btn-warning px-4" [disabled]="!bankForm.valid"
                                                type="submit">
                                                Submit
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>